import React from "react";
import { Card, Col, Descriptions, Row } from "antd";

import MainLayout from "components/MainLayout";

import useGet from "hooks/useGet";
import PageFailure from "components/PageFailure";
import dayjs from "dayjs";
import formatPrice from "helpers/formatPrice";
import IssuesList from "./components/IssuesList";

const CurrentBillingSummary = () => {
  const path = "/billing_summaries/current";

  const {
    is_loading,
    is_error,
    data = {},
  } = useGet({
    path,
    query: ["billing_summary_current"],
  });

  if (is_error) {
    return (
      <PageFailure
        title="Nie znaleziono rozliczenia"
        button_text="Wróć do listy"
        path="/billings"
      />
    );
  }

  return (
    <MainLayout
      back_href="/billings"
      breadcrumbs={[
        { name: "Moje faktury", path: "/billings" },
        { name: "Rozliczenia za obecny miesiąc" },
      ]}
    >
      <Row gutter={24} className="billing-container">
        <Col xl={12} lg={24} sm={24} xs={24}>
          <IssuesList />
        </Col>
        <Col xl={12} lg={24} sm={24} xs={24} className="billing-summary">
          <Card style={{ marginBottom: 24 }} loading={is_loading}>
            <Descriptions
              bordered
              size="small"
              items={[
                {
                  label: "ID",
                  children: "2f7e1671-8a49-49fb-81ce-820306ae95b9",
                  span: 3,
                },
                {
                  label: "Okres rozliczenia",
                  children: data?.period_start
                    ? `${dayjs(data.period_start).format("DD")} - ${dayjs(
                        data.period_end
                      ).format("DD MMMM YYYY")}`
                    : "-",
                  span: 3,
                },
                {
                  label: "Ilość zgłoszeń",
                  children: data?.billed_issues_count,
                  span: 3,
                },
                {
                  label: "Cena za zgłoszenie",
                  children: data?.single_issue_fee
                    ? formatPrice(data.single_issue_fee, data.currency)
                    : "-",
                  span: 3,
                },
                {
                  label: "Koszt zgłoszeń",
                  children: data?.usage_fee
                    ? ["~", formatPrice(data.usage_fee, data.currency)].join("")
                    : "-",
                  span: 3,
                },
                {
                  label: "Abonament",
                  children: data?.base_fee
                    ? formatPrice(data.base_fee, data.currency)
                    : "-",
                  span: 3,
                },
                {
                  label: <strong>Kwota całkowita</strong>,
                  children: data?.total_amount ? (
                    <strong>
                      ~ {formatPrice(data.total_amount, data.currency)}
                    </strong>
                  ) : (
                    "-"
                  ),
                  span: 3,
                },
                {
                  label: "Nr FV",
                  children: "-",
                  span: 3,
                },
                {
                  label: "Status",
                  children: "-",
                  span: 3,
                },
                {
                  label: "Termin płatności",
                  children: "-",
                  span: 3,
                },
                {
                  label: "Data płatności",
                  children: "-",
                  span: 3,
                },
              ]}
            />
          </Card>
        </Col>
      </Row>
    </MainLayout>
  );
};

export default CurrentBillingSummary;
